import { render, staticRenderFns } from "./verifiedShield.vue?vue&type=template&id=41fa26b9&"
import script from "./verifiedShield.vue?vue&type=script&lang=js&"
export * from "./verifiedShield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports